var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.4,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6512_17810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.46605 11.4602H7.52605V6.7202H8.46605V11.4602ZM8.62605 5.0102C8.62605 5.18354 8.56272 5.32687 8.43605 5.4402C8.31605 5.55354 8.16939 5.6102 7.99605 5.6102C7.82272 5.6102 7.67605 5.55354 7.55605 5.4402C7.43605 5.3202 7.37605 5.17687 7.37605 5.0102C7.37605 4.83687 7.43605 4.69354 7.55605 4.5802C7.67605 4.4602 7.82272 4.4002 7.99605 4.4002C8.16939 4.4002 8.31605 4.4602 8.43605 4.5802C8.56272 4.69354 8.62605 4.83687 8.62605 5.0102Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6512_17810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.7ed208abf711f8f62f8b60fd38bb3332.svg";
export { ForwardRef as ReactComponent };